'use client';

import React, { useCallback, useMemo } from 'react';
import { queryStringConstants, VIEW } from '@/constants/queryConstants';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from '@/lib/router-events/patch-router/router';
import { prepareUrl } from '@/utils/urlHelper';
import Icon from '@/components/shared/Icons';

export default function ToggleViewButton({
  strings
}: {
  strings: {
    listViewText: string;
    mapViewText: string;
  };
}): JSX.Element {
  const router = useRouter();
  const searchParams = useSearchParams();
  const view = useMemo(() => searchParams?.get(queryStringConstants.VIEW), [searchParams]);
  const pathname = usePathname();

  const handleClick = useCallback(
    viewValue => {
      router.push(prepareUrl(pathname, searchParams, { key: queryStringConstants.VIEW, value: viewValue }));
    },
    [pathname, router, searchParams]
  );
  return (
    <div className="hidden lg:block lg:flex xl:hidden" role="group">
      <button
        type="button"
        className={`flex h-11 w-28 rounded-l-xl border-1 border-neutral-30 ${
          view !== VIEW.MAP ? 'bg-brand-20' : ''
        } px-6 py-2`}
        onClick={() => {
          handleClick(VIEW.LIST);
        }}
        data-cvent-id="srp-toggle-view"
      >
        <div className="flex">
          <Icon id="list" className={`mx-1 h-5 w-5 pt-1 ${view !== VIEW.MAP ? 'fill-brand-70' : 'fill-neutral-60'}`} />
          <span className={`text-b-base ${view !== VIEW.MAP ? 'text-brand-70' : 'text-neutral-60'}`}>
            {strings.listViewText}
          </span>
        </div>
      </button>
      <button
        type="button"
        className={`flex h-11 w-32 rounded-r-xl border-1 border-neutral-30 ${
          view === VIEW.MAP ? 'bg-brand-20' : ''
        } py-2 pl-6`}
        onClick={() => {
          handleClick(VIEW.MAP);
        }}
        data-cvent-id="srp-toggle-view"
      >
        <div className="flex">
          <Icon
            id="map-pin"
            className={`mx-1 h-5 w-5 pt-1 ${view === VIEW.MAP ? 'fill-brand-70' : 'fill-neutral-60'}`}
          />
          <span className={`text-b-base ${view === VIEW.MAP ? 'text-brand-70' : 'text-neutral-60'}`}>
            {strings.mapViewText}
          </span>
        </div>
      </button>
    </div>
  );
}
